import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

const unauthorizedMW: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { payload } = action || {};
    const { originalStatus } = payload || {};

    if (originalStatus === 401) {
      window.location.replace('/');
    }
  }

  return next(action);
};

export default unauthorizedMW;
